/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A20Inputs */

const et_faq_a20 = /** @type {(inputs: Faq_A20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parimad SEO teenused Tallinnas ühendavad tehnilise SEO, kohaliku otsinguoptimeerimise (Local SEO), Google Business Profile'i halduse, sisuturunduse ja linkide kasvatamise üheks kasvusüsteemiks. ScalingWebs on Tallinnast tegutsev agentuur, mis pakub tulemuspõhist SEO teenust teenusettevõtetele ja agentuuridele. Meie töö hõlmab Google Mapsi nähtavust, teenusepõhiseid maandumislehti ja orgaanilise liikluse kasvatamist. Broneeri tasuta 15-minutiline konsultatsioon, et saada teada, kui kiiresti saad Google'i esimesele lehele.`)
};

const en_faq_a20 = /** @type {(inputs: Faq_A20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The best SEO services in Tallinn combine technical SEO, local search optimization, Google Business Profile management, content marketing, and link building into one growth system. ScalingWebs is a Tallinn-based agency offering results-driven SEO for service businesses and agencies. Our work covers Google Maps visibility, service-specific landing pages, and organic traffic growth. Book a free 15-minute consultation to find out how quickly you can reach the first page of Google.`)
};

/**
* | output |
* | --- |
* | "The best SEO services in Tallinn combine technical SEO, local search optimization, Google Business Profile management, content marketing, and link building i..." |
*
* @param {Faq_A20Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a20 = /** @type {((inputs?: Faq_A20Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A20Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a20(inputs)
	return en_faq_a20(inputs)
});